import Vue from 'vue';

import CachedCompanyData from '@/cache/CachedCompanyData';

export default class CachedLocationCategories extends CachedCompanyData {
  async retrieveData() {
    const response = await Vue.prototype.$globals.companyClient.getLocationCategories();
    return response.results;
  }

  getCacheExpiration() {
    return 10 * 60 * 1000;
  }

  get invalidateCacheOnCompanyChange() {
    return false;
  }
}
